

import React, { memo, useState } from 'react';
import _isEmpty from 'lodash.isempty';
import { Divider, Text } from '../../../../../../ui-kit';
import { getCostRange } from '../../../../utils';
import SingleValueAddon from '../../components/SingleValueAddon';
import MultiValueAddon from '../../components/MultiValueAddon';
import ToggleValueAddon from '../../components/ToggleValueAddon';

import '../styles/_captions.scss';

















function disableOption(disabledValues) {
  return (option) => {
    if (disabledValues.includes(option.value)) {
      return { ...option, disabled: true };
    }
    return option;
  };
}

function disableOptions(
options,
disabledOptions)
{
  if (!Array.isArray(disabledOptions) || !disabledOptions.length) {
    return options;
  }
  const disabledValues = disabledOptions.map((option) => option.value);
  return options.map(disableOption(disabledValues));
}

const Captions = ({
  burnInCaptions,
  srtCaptions,
  onChangeAddon,
  disabled,
  BURN_IN_CAPTIONS,
  SRT_CAPTIONS,
  editingMode,
  showAboutInfo,
  getCurrencySymbol,
  disabledOptions,
  dropdownType,
  resetAddonValuesByType,
  onCaptionsToggleChange
}) => {
  const hasSelectedCaptions = !!burnInCaptions?.value || !_isEmpty(srtCaptions);
  const [toggle, setToggle] = useState(hasSelectedCaptions);

  const onToggleChange = (value) => {
    if (typeof onCaptionsToggleChange === 'function') {
      onCaptionsToggleChange(value);
    }
    if (!value) {
      // Handling when toggle is turned OFF: Resetting caption addons to defaults
      resetAddonValuesByType('CAPTIONS');
      setToggle(false);
      return;
    }
    setToggle(true);
  };

  const {
    minCost: burnInMinCost,
    maxCost: burnInMaxCost,
    currencySymbol: burnInCurrencySymbol
  } = !_isEmpty(BURN_IN_CAPTIONS) ? getCostRange(BURN_IN_CAPTIONS) : {};

  const {
    minCost: srtMinCost,
    maxCost: srtMaxCost,
    currencySymbol: srtCurrencySymbol
  } = !_isEmpty(SRT_CAPTIONS) ? getCostRange(SRT_CAPTIONS) : {};

  const minCost = burnInMinCost < srtMinCost ? burnInMinCost : srtMinCost;
  const maxCost = burnInMaxCost > srtMaxCost ? burnInMaxCost : srtMaxCost;
  const currencySymbol = burnInCurrencySymbol || srtCurrencySymbol;

  const renderToggleChildren = () =>
  <div className="captions__children">
      <Divider />
      <div className="captions__children__burn-in">
        <Text className="captions__children__label">Burn In</Text>
        <SingleValueAddon
        name="BURN_IN_CAPTIONS"
        options={BURN_IN_CAPTIONS}
        addonValue={burnInCaptions}
        icon="burnin"
        onChangeAddon={onChangeAddon('BURN_IN_CAPTIONS')}
        disabled={disabled}
        editingMode={editingMode}
        showAboutInfo={showAboutInfo}
        hideCheckbox />

      </div>
      <div className="captions__children__srt">
        <Text className="captions__children__label">SRT</Text>
        <MultiValueAddon
        name="SRT_CAPTIONS"
        options={disableOptions(SRT_CAPTIONS, disabledOptions)}
        addonValue={srtCaptions}
        icon="transcribe"
        onChangeAddon={onChangeAddon('SRT_CAPTIONS')}
        disabled={disabled}
        dropdownType={dropdownType}
        getCurrencySymbol={getCurrencySymbol}
        editingMode={editingMode}
        addItemLabel="Additional Caption"
        showAboutInfo={showAboutInfo}
        hideCheckbox />

      </div>
    </div>;


  return (
    <div className="captions">
      <ToggleValueAddon
        id="captions"
        title="Captions"
        subtitle="Spoken English videos only. Allow up to 48-72 hours."
        icon="captions"
        costString={`${currencySymbol}${minCost}-${currencySymbol}${maxCost}`}
        selected={toggle}
        onChange={onToggleChange}
        disabled={disabled}>

        {renderToggleChildren()}
      </ToggleValueAddon>
    </div>);

};

export default memo(Captions);